import { parseDate } from "../../../../../utils/functions";

export default class TimerStart {
    parse(data) {
        this.id = data.id;
        this.time = parseDate(data.time);
        return this;
    }
}
